const Colors = {
  darkBg: 'rgb(50,50,50)',
  lightBg: '#dbdbdb',
};

export default Colors;
